import React, { useEffect, useState } from 'react';
import { useAuth } from '../../../AuthProvider';
import { useNavigate, useParams, useLocation } from "react-router-dom";
import {
 Select,
  FormControl, InputLabel,MenuItem,Menu, ListItemIcon, ListItemText, Stack
} from "@mui/material";
import DirectionsBusIcon from '@mui/icons-material/DirectionsBus';
import { Card, Typography, Box, Grid, IconButton ,Button} from "@mui/material";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";

// Animations
const extraKeyframes = `
@keyframes pulse {
  0% { box-shadow: 0 0 0 0 rgba(16,185,129,0.7); }
  70% { box-shadow: 0 0 0 14px rgba(16,185,129,0); }
  100% { box-shadow: 0 0 0 0 rgba(16,185,129,0); }
}
@keyframes dashmove {
  100% { stroke-dashoffset: -50; }
}
`;

const ROAD_ROW_HEIGHT = 100;
const STOPS_PER_ROW = 5;

function chunkStops(stops, perRow) {
  const rows = [];
  for (let i = 0; i < stops.length; i += perRow) {
    rows.push(stops.slice(i, i + perRow));
  }
  return rows;
}

function getStopPositionZigZag(rowIdx, stopIdx, stopsInRow, direction, width, left) {
  const y = 80 + rowIdx * ROAD_ROW_HEIGHT;
  const t = stopsInRow === 1 ? 0 : stopIdx / (stopsInRow - 1);
  const x = direction
    ? left + t * width
    : left + (1 - t) * width;
  return { x, y };
}

const BusTracking = () => {
   const { oId ,role,pId} = useAuth();
     const navigate = useNavigate();
    // const { route } = useParams();
//   const storedBusId = sessionStorage.getItem("busId");
// const storedRoute = sessionStorage.getItem("route");


const location = useLocation();
const storedBusId = location.state?.busId;
const storedRoute = location.state?.route;




  const [busData, setBusData] = useState([]);
  const [selectedBus, setSelectedBus] = useState("");
  const [trips, setTrips] = useState([]);
  const [selectedTrip, setSelectedTrip] = useState("");

  const [stops, setStops] = useState([]);
  const [currentStop, setCurrentStop] = useState('');
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [hoveredStop, setHoveredStop] = useState(null);
  const [containerWidth, setContainerWidth] = useState(700);



 
  const baseUrl = process.env.REACT_APP_API_BASE_URL;


 const [users, setUsers] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState('');
  const isPrincipal = role?.startsWith("PRINCIPAL") || false;
 

    useEffect(() => {
    const fetchUsers = async () => {
        try {
            const response = await fetch(`${baseUrl}/api/principal/getAllUserIdsAndNames/TRANSPORT/${oId}/${pId}`);
            if (!response.ok) {
                throw new Error('Failed to fetch users');
            }
            const data = await response.json();
            setUsers(data);
            if (data.length > 0) {
              setSelectedUsers(data[0].userId); // ✅ Set first record's userId as default
          }
        } catch (error) {
            console.error('Error fetching users:', error);
        }
    };
    fetchUsers();
}, []);





  // Responsive: Track container width
  const containerRef = React.useRef();
  useEffect(() => {
    function handleResize() {
      if (containerRef.current) {
        setContainerWidth(containerRef.current.offsetWidth - 40); // padding
      }
    }
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

useEffect(() => {
  const fetchBusNumbers = async () => {
    if (!selectedUsers) return;
    try {
      const res = await fetch(
        `${baseUrl}/api/SchedulingRoute/bus-numbers/${oId}/${selectedUsers}`
      );
      const data = await res.json();

      setBusData(data || []);

      if (data.length > 0) {
        if (storedBusId && data.some((bus) => bus.busNumber === storedBusId)) {
          // ✅ set bus by busNumber from storage
          setSelectedBus(storedBusId);
        } else {
          // ✅ fallback to first busNumber
          setSelectedBus(data[0].busNumber);
        }
      }
    } catch (err) {
      console.error("Bus number fetch error:", err);
    }
  };

  fetchBusNumbers();
}, [selectedUsers, baseUrl, oId]);



// Fetch trips
const fetchTrips = async () => {
    if(!selectedBus) return;
  try {
    const response = await fetch(`${baseUrl}/api/SchedulingRoute/getAll/trips/${selectedBus}`); // replace with your endpoint
    if (!response.ok) throw new Error("Failed to fetch trips");
    const data = await response.json();
    setTrips(data);
    // setSelectedTrip(data[0])
     if (data.length > 0) {
        if (storedRoute && data.includes(storedRoute)) {
          setSelectedTrip(storedRoute);
        } else {
          setSelectedTrip(data[0]); // fallback to first trip
        }
      }
  } catch (error) {
    console.error("Error fetching trips:", error);
  }
};

useEffect(() => {
  fetchTrips();
}, [selectedBus]);

// refresh from onmount
// useEffect(() => {
//   if (selectedBus || selectedTrip) {
//     sessionStorage.removeItem("busId");
//     sessionStorage.removeItem("route");
//   }
// }, []); // run once on mount





const fetchStopsAndStatus = async () => {
  if (!selectedBus || !selectedTrip) return;

  setLoading(true);

  try {
    // Fetch stops from API
    const res = await fetch(`${baseUrl}/api/SchedulingRoute/stops/bus/${selectedBus}/${selectedTrip}/${oId}/${pId}`);
    const data = await res.json();

    // let stopsArray = [];

    // if (Array.isArray(data?.stops)) {
    //   // Extract and trim each stop name
    //   stopsArray = data.stops.map(item => item.stop.trim());
    // }

    // setStops(stopsArray);
    let stopsArray = [];

    // data.stops is an array of stop strings
    if (Array.isArray(data?.stops)) {
      stopsArray = data.stops.map((stop) => stop.trim());
    }

    setStops(stopsArray);

    // If you also need to update busId and trip from response
    const busId = data.busNumber;
    const trip = data.route;
    if (busId) {
      const locRes = await fetch(`${baseUrl}/api/bus/location/${busId}/${trip}`);
      const locData = await locRes.json();
      setCurrentStop(locData.stop?.trim() || '');
    } else {
      setCurrentStop('');
    }

  } catch (err) {
    console.error('Stops/status fetch error:', err);
    setStops([]);
    setCurrentStop('');
  } finally {
    setLoading(false);
  }
};

useEffect(()=>{
  fetchStopsAndStatus();
},[selectedBus,selectedTrip, baseUrl, oId])

  // Color palette
  const colors = {
    background: '#f8fafc',
    cardGradient: 'rgba(255,255,255,0.9)',
    cardShadow: '0 8px 32px 0 rgba(56, 189, 248, 0.10)',
    text: '#0f172a',
    line: '#232b3b',
    dashed: '#fff',
    current: '#10B981', // GREEN for current stop
    passed: '#BDBDBD',
    upcoming: '#bd7dd4',
    stopText: '#fff',
    border: '#fff',
    legendBg: '#f1f5f9',
    stopHeading: '#334155',
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest('.bus-dropdown')) setDropdownVisible(false);
    };
    if (dropdownVisible) document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [dropdownVisible]);

  // Find the current stop index
  const currentIdx = stops.findIndex(s => s === currentStop);

  const stopRows = chunkStops(stops, STOPS_PER_ROW);

  // Responsive SVG sizing
  const ROAD_WIDTH = Math.max(containerWidth - 120, 200); // leave some margin
  const ROAD_LEFT = 60;
  const SVG_HEIGHT = 80 + stopRows.length * ROAD_ROW_HEIGHT;

  return (
    <div style={styles.bg(colors)}>
      <style>{extraKeyframes}</style>
      <style>{responsiveCSS}</style>
      <div style={styles.card(colors)} ref={containerRef}>
        {/* Card background image */}
        <div style={styles.cardBgImage}></div>
         <Box display="flex" alignItems="center">
                    <IconButton onClick={() => navigate(-1)} sx={{ color: "#2e2a54" }}>
                      <KeyboardBackspaceIcon fontSize="medium" />
                    </IconButton>
                    <Typography variant="h3" sx={{ fontWeight: "bold" }}>
                      Bus Route Map
                    </Typography>
                  </Box>
        <div >
          {/* <h2 style={styles.heading(colors)}>
            <span style={{
              color: 'black',
              fontWeight: "bold",
            }}>
              Bus Route Map
            </span>
          </h2> */}

          
        </div>

        {/* Picker fixed at top left below heading */}
      
<div
  style={{
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 10,
  }}
>
  {/* LEFT: Bus Picker + Trip Field together */}
  <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>

    {/* Bus Select field */}
  <FormControl style={{ width: "180px" }} size="small">
      <InputLabel>Select Bus</InputLabel>
      <Select
        value={selectedBus}
        onChange={(e) => setSelectedBus(e.target.value)}
        label="Select Bus"
      >
        {busData.map((bus) => (
          <MenuItem key={bus.busNumber} value={bus.busNumber}>
           {bus.busNumberPlate}
          </MenuItem>
        ))}
      </Select>
    </FormControl>


    {/* Trip Field */}
    <FormControl style={{ width: "150px" }} size="small">
      <InputLabel>Select Trip</InputLabel>
      <Select
        value={selectedTrip}
        onChange={(e) => setSelectedTrip(e.target.value)}
        label="Select Trip"
      >
        {trips.map((trip) => (
          <MenuItem key={trip} value={trip}>
            {trip}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  </div>

  {/* RIGHT: Admin Selector */}
  {/* {isPrincipal && (
    <FormControl style={{ width: "220px" }} size="small">
      <InputLabel>Select Transport UserId</InputLabel>
      <Select
        value={selectedUsers}
        onChange={(e) => setSelectedUsers(e.target.value)}
        label="Select Transport UserId"
      >
        {users.map((user) => (
          <MenuItem key={user.userId} value={user.userId}>
            {user.userId}-{user.firstName} {user.lastName}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )} */}
</div>






        <div style={styles.wrapper}>
          {/* Left: Legend */}
          <div style={styles.legend(colors)}>
            <div style={styles.legendItem}>
              <span style={{ ...styles.legendCircle, background: colors.current, borderColor: colors.current }} />
              <span style={styles.legendLabel}>Current Stop</span>
            </div>
            <div style={styles.legendItem}>
              <span style={{ ...styles.legendCircle, background: colors.passed, borderColor: colors.passed }} />
              <span style={styles.legendLabel}>Previous Stop</span>
            </div>
            <div style={styles.legendItem}>
              <span style={{ ...styles.legendCircle, background: colors.upcoming, borderColor: colors.upcoming }} />
              <span style={styles.legendLabel}>Upcoming Stop</span>
            </div>
          </div>
          {/* Right: Road/Stops */}
          <div style={styles.roadContainer}>
            {loading ? (
              <p style={styles.loading}>Loading route...</p>
            ) : stops.length === 0 ? (
              <p style={styles.loading}>No stops found for this bus.</p>
            ) : (
              <svg
                width={ROAD_WIDTH + 2 * ROAD_LEFT}
                height={SVG_HEIGHT}
                style={{ display: 'block', marginTop:20, maxWidth: '100%', width: '100%',marginLeft:10 }}
                viewBox={`0 0 ${ROAD_WIDTH + 2 * ROAD_LEFT} ${SVG_HEIGHT}`}
                preserveAspectRatio="xMidYMin meet"
              >
                {/* Draw roads for each row */}
                {stopRows.map((row, rowIdx) => {
                  const direction = rowIdx % 2 === 0;
                  const y = 80 + rowIdx * ROAD_ROW_HEIGHT;
                  const x1 = direction ? ROAD_LEFT : ROAD_LEFT + ROAD_WIDTH;
                  const x2 = direction ? ROAD_LEFT + ROAD_WIDTH : ROAD_LEFT;
                  return (
                    <g key={rowIdx}>
                      {/* Main road line */}
                      <line
                        x1={x1}
                        y1={y}
                        x2={x2}
                        y2={y}
                        stroke={colors.line}
                        strokeWidth={28}
                        strokeLinecap="round"
                      />
                      {/* Dashed center line (animated) */}
                      <line
                        x1={x1}
                        y1={y}
                        x2={x2}
                        y2={y}
                        stroke={colors.dashed}
                        strokeWidth={6}
                        strokeDasharray="32,18"
                        strokeLinecap="round"
                        style={{ animation: 'dashmove 2s linear infinite' }}
                      />
                      {/* Shadow */}
                      <line
                        x1={x1}
                        y1={y + 12}
                        x2={x2}
                        y2={y + 12}
                        stroke="#0002"
                        strokeWidth={34}
                        style={{ filter: "blur(8px)" }}
                      />
                      {/* Connector to next row */}
                      {rowIdx < stopRows.length - 1 && (
                        <line
                          x1={x2}
                          y1={y}
                          x2={x2}
                          y2={y + ROAD_ROW_HEIGHT}
                          stroke={colors.line}
                          strokeWidth={20}
                          strokeLinecap="round"
                        />
                      )}
                    </g>
                  );
                })}
                {/* Stops */}
                {stopRows.map((row, rowIdx) => {
                  const direction = rowIdx % 2 === 0;
                  return row.map((stop, i) => {
                    const globalIdx = rowIdx * STOPS_PER_ROW + i;
                    // Color logic: if currentIdx === -1, all upcoming; else, current is green, passed is cyan, rest upcoming
                    const isActive = stop === currentStop && currentIdx !== -1;
                    const isPassed = currentIdx !== -1 && currentIdx > globalIdx;
                    const { x, y } = getStopPositionZigZag(rowIdx, i, row.length, direction, ROAD_WIDTH, ROAD_LEFT);
                    return (
                     <g
  key={`${rowIdx}-${i}`}
  onMouseEnter={() => setHoveredStop({ x, y, stop })}
  onMouseLeave={() => setHoveredStop(null)}
>
  {/* Stop circle */}
  <circle
    cx={x}
    cy={y}
    r={isActive ? 27 : 20}
    fill={
      currentIdx === -1
        ? colors.upcoming
        : isActive
          ? colors.current
          : isPassed
            ? colors.passed
            : colors.upcoming
    }
    stroke={colors.border}
    strokeWidth={5}
    style={{
      filter: isActive
        ? "drop-shadow(0 2px 18px #10B981bb)"
        : isPassed
          ? "drop-shadow(0 2px 8px #06b6d488)"
          : "drop-shadow(0 2px 8px #6366f155)",
      transition: "all 0.4s cubic-bezier(.4,2,.5,1)",
      ...(isActive && { animation: 'pulse 1.2s infinite' })
    }}
  />

  {/* 🚌 Material Bus Icon on Current Stop */}
  {isActive && (
    <foreignObject x={x - 16} y={y - 16} width={32} height={32}>
      <div
        style={{
          width: '100%',
          height: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <DirectionsBusIcon style={{ color: 'white', fontSize: 28 }} />
      </div>
    </foreignObject>
  )}

  {/* Stop number */}
  <text
    x={x}
    y={y + 8}
    textAnchor="middle"
    fontSize={isActive ? 0 : 18}
    fill={colors.stopText}
    fontWeight="bold"
    style={{
      opacity: isActive ? 0 : isPassed ? 0.9 : 0.7,
      fontFamily: 'monospace',
      pointerEvents: 'none'
    }}
  >
    {globalIdx + 1}
  </text>
  {/* Stop name */}
  <text
  x={x}
  y={y + 43}
  textAnchor="middle"
  fontSize={isActive ? 16 : 14}
  fill="black"  // <--- force black color here
  fontWeight={isActive ? 900 : isPassed ? 700 : 600}
  style={{
    textShadow: "0 2px 8px #fff",
    background: "#fff",
    borderRadius: 8,
    padding: "2px 6px",
    letterSpacing: isActive ? '0.5px' : '0.2px',
    filter: isActive ? "drop-shadow(0 0 8px #10B981aa)" : undefined
  }}
>
  {stop}
</text>

</g>

                    );
                  });
                })}
              </svg>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

// Responsive CSS for mobile/tablet
const responsiveCSS = `
@media (max-width: 900px) {
  .busroute-wrapper {
    flex-direction: column !important;
    gap: 24px !important;
    padding: 10px 2vw !important;
  }
}
@media (max-width: 700px) {
  .busroute-wrapper {
    flex-direction: column !important;
    gap: 18px !important;
    padding: 8px 1vw !important;
  }
}
`;

const styles = {
  bg: (colors) => ({
    minHeight: '80vh',
    background: colors.background,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '32px 8px',
  }),
  card: (colors) => ({
    background: colors.cardGradient,
    boxShadow: colors.cardShadow,
    borderRadius: '32px',
    padding: '10px 32px 10px 20px',
    width: '100%',
    minWidth: 0,
    maxHeight: '88vh',
    border: '2.5px solid #e0e7ef',
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    position: 'relative',
    marginTop: '30px',
    overflow: 'hidden',
  }),
  cardBgImage: {
    position: 'absolute',
    top: 0, left: 0, right: 0, bottom: 0,
    zIndex: 0,
    borderRadius: '32px',
    backgroundImage: 'url("https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=1100&q=80")',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    opacity: 0.18,
    pointerEvents: 'none'
  },
  headerRow: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    width: '100%',
    marginBottom: 0,
    flexWrap: 'wrap',
    gap: '10px',
    zIndex: 1,
  },
  heading: (colors) => ({
    fontSize: '1.3rem',
    color: colors.stopHeading,
    fontWeight: 600,
    margin: 0,
    textShadow: '0 2px 8px rgba(0,0,0,0.05)',
    lineHeight: 1.2,
    zIndex: 1,
  }),
  fixedPicker: {
    // position: 'absolute',
    // left: 30,
    // top: 80,
    // zIndex: 10,
    // minWidth: 120,
    // width: 180,
    // height: 38,
    // marginBottom: 5

     minWidth: 120,
  width: 180,
  height: 38,
  marginBottom: 5,
  },
  selector: (colors) => ({
    padding: '7px 10px',
    borderRadius: '8px',
    border: `1.5px solid ${colors.upcoming}`,
    background: '#fff',
    fontSize: '0.98rem',
    fontWeight: 600,
    color: colors.text,
    cursor: 'pointer',
    userSelect: 'none',
    transition: 'box-shadow 0.2s',
    boxShadow: '0 2px 8px rgba(99,102,241,0.08)',
    marginBottom: 0,
    width: '100%',
    height: 34,
    minHeight: 34,
    lineHeight: '18px',
    zIndex: 10,
  }),
  dropdown: {
    position: 'absolute',
    left: 0,
    top: 38,
    width: '100%',
    background: '#fff',
    border: '1px solid #e0e7ef',
    borderRadius: 8,
    boxShadow: '0 8px 24px rgba(99,102,241,0.14)',
    zIndex: 20,
    maxHeight: 220,
    overflowY: 'auto',
  },
  dropdownItem: {
    padding: '8px 12px',
    cursor: 'pointer',
    fontSize: '1rem',
    color: '#334155',
    borderBottom: '1px solid #f1f5f9',
    transition: 'background 0.15s',
  },
  wrapper: {
    display: 'flex',
    flexDirection: 'row',
    gap: 40,
    width: '100%',
    padding: '18px 4vw 18px 2vw',
    zIndex: 1,
    minHeight: 320,
    alignItems: 'flex-start',
    justifyContent: 'center',
    // marginTop:40
  },
  legend: (colors) => ({
    // background: colors.legendBg,
    borderRadius: 18,
    padding: '22px 18px 18px 18px',
    marginRight: 15,
    minWidth: 160,
    maxWidth: 180,
    boxShadow: '0 2px 8px #e0e7ef',
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
    alignItems: 'flex-start',
    zIndex: 2,
    marginTop:100
  }),
  legendItem: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    marginBottom: 4,
  },
  legendCircle: {
    width: 18,
    height: 18,
    borderRadius: 10,
    border: '2.5px solid #fff',
    display: 'inline-block',
    boxShadow: '0 2px 8px #e0e7ef',
    marginRight: 7,
  },
  legendLabel: {
    fontSize: 13,
    fontWeight: 600,
    color: '#334155',
    letterSpacing: 0.1,
  },
  roadContainer: {
    flex: 1,
    minWidth: 0,
    maxWidth: '100%',
    position: 'relative',
    zIndex: 2,
    paddingBottom: 30,
    // paddingTop: 2,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

  },
  loading: {
    fontWeight: 600,
    color: '#334155',
    fontSize: 18,
    textAlign: 'center',
    padding: '40px 0',
    opacity: 0.7,
  },
};

export default BusTracking;